import React from 'react';

import { SubHeading } from '../../components'
import { images } from '../../constants'
import './Founder.css';

const Founder = () => (
  <div className="app__bg app__wrapper section__padding">
    <div className="app__wrapper_img app__wrapper_img-reverse">
      <img src={images.ps} alt="ps" />
    </div>

    <div className="app__wrapper_info">
      <SubHeading title="Founder" />
      <h1 className="headtext__cormorant">What we believe in</h1>
      
      <div className="app__founder-content">
        <div className="app__founder-content_quote">
          <img src={images.quote} alt="quote" />
          <p className="p__opensans">Apakah tidak lucu, </p>
        </div>
        <p className="p__opensans">ketika seseorang mengatakan bahwa mengalahkan diri sendiri adalah kunci keberhasilan? Saya berpikir itu mungkin bekerja untuk orang lain, tetapi saya lebih suka berbaring di sofa dan berpikir tentang es krim.</p>
      </div>

      <div className="app__founder-sign">
        <p>Patrick Star</p>
        <p className="p__opensans">CEO & Founder</p>
        <img src={images.ttd} alt="ttd" />
      </div>
    </div>
  </div>
);

export default Founder;
